import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { CandidateNavbar } from '@core/layout/candidate/candidate-navbar/candidate-navbar';
@Component({
  selector: 'app-candidate',
  template: `
    <div class="h-dvh flex flex-col">
      <app-candidate-navbar />
      <div
        class="flex-1 lg:pt-30 pt-25 lg:pb-10 pb-5 lg:px-10 px-5 bg-base-200">
        <router-outlet />
      </div>
    </div>
  `,
  imports: [CandidateNavbar, RouterOutlet],
})
export class CandidateLayout {}
